import React from "react";
import ResultView from "@/note_office/shared/ResultView";
import translator from "@/translator";
import Bee from "@/note_office/icons/Bee.png";
import Blob from "@/note_office/icons/Blob.png";
import RedirectButton from "@/note_office/shared/RedirectButton";

const t = translator("note_office.views.payments.transaction_view.");

const IndexView = ({ payment_success, subscription_url }) => {
  const resultText = payment_success ? t("success") : t("failed");
  const resultImage = payment_success ? Bee : Blob;

  return (
    <ResultView
      image={resultImage}
      title={resultText}
      className="wrapper__menu-layout"
      buttons={[
        <RedirectButton
          key="main"
          type="primary"
          block
          className="button-base"
          url={subscription_url}
        >
          {t("back_to")}
        </RedirectButton>,
      ]}
    />
  );
};

export default IndexView;
